"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPMENT_ROLES = void 0;
var SHIPMENT_ROLES;
(function (SHIPMENT_ROLES) {
    SHIPMENT_ROLES["SEARCH_SHIPMENTS"] = "search-shipments";
    SHIPMENT_ROLES["VIEW_SHIPMENT"] = "view-shipment";
    SHIPMENT_ROLES["CREATE_SHIPMENT"] = "create-shipment";
    SHIPMENT_ROLES["MODIFY_SHIPMENT"] = "modify-shipment";
    SHIPMENT_ROLES["MODIFY_SHIPMENT_STATUS"] = "modify-shipment-status";
    SHIPMENT_ROLES["SEARCH_PACKAGING_SETS"] = "search-packaging-sets";
    SHIPMENT_ROLES["VIEW_PACKAGING_SET"] = "view-packaging-set";
    SHIPMENT_ROLES["CREATE_PACKAGING_SET"] = "create-packaging-set";
    SHIPMENT_ROLES["MODIFY_PACKAGING_SET"] = "modify-packaging-set";
    SHIPMENT_ROLES["MODIFY_PACKAGING_SET_ALLOCATION"] = "modify-packaging-set-allocation";
    SHIPMENT_ROLES["MODIFY_PACKAGING_SET_SHIPPING"] = "modify-packaging-set-shipping";
    SHIPMENT_ROLES["APPROVE_PACKAGING_SET_SHIPPING"] = "approve-packaging-set-shipping";
    SHIPMENT_ROLES["DELETE_PACKAGING_SET"] = "delete-packaging-set";
})(SHIPMENT_ROLES = exports.SHIPMENT_ROLES || (exports.SHIPMENT_ROLES = {}));
//# sourceMappingURL=shipment.roles.js.map